import React from 'react';
import { createSvgIcon } from '@mui/material';

const PaperClipIcon = createSvgIcon(
  <svg viewBox="0 0 18 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7.34757 0.730553C7.68048 1.04834 7.69273 1.57584 7.37494 1.90875L3.64702 5.81399C1.89555 7.64877 1.89555 10.6389 3.64702 12.4737C5.37761 14.2866 8.16671 14.2866 9.8973 12.4737L14.8679 7.26666C15.933 6.15082 15.933 4.32634 14.8679 3.21049L15.4706 2.63508L14.8679 3.21049C13.8236 2.11652 12.1472 2.11652 11.1029 3.21049L6.1323 8.41749C5.75341 8.8144 5.75341 9.47325 6.1323 9.87016C6.49031 10.2452 7.05401 10.2452 7.41202 9.87016L12.3826 4.66317C12.7004 4.33026 13.2279 4.31801 13.5608 4.6358C13.8937 4.95359 13.9059 5.48108 13.5881 5.81399L8.61758 11.021C7.60301 12.0838 5.94131 12.0838 4.92674 11.021C3.93304 9.98002 3.93304 8.30762 4.92674 7.26666L9.8973 2.05967C11.5982 0.277904 14.3726 0.277905 16.0734 2.05967L15.4786 2.62752L16.0734 2.05967C17.7534 3.81957 17.7534 6.65759 16.0734 8.41749L11.1029 13.6245C8.71571 16.1252 4.82861 16.1252 2.44146 13.6245C0.0751789 11.1456 0.0751789 7.142 2.44146 4.66317L6.16938 0.757923C6.48717 0.425016 7.01466 0.412762 7.34757 0.730553Z"
      fill="currentColor"
    />
  </svg>,
  'PaperClipIcon',
);

export default PaperClipIcon;
